import React, { useRef, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Controller } from "swiper/modules";
import Image from "next/image";
import useWindowSize from "@/hooks/useWindowSize";
import { ArrowLeftIcon, ArrowRightIcon } from "@heroicons/react/outline";
import * as Text from "@/components/text";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default function Partners({ arrayPartners }) {
  const beforeRef = useRef(null);
  const paginationRef = useRef(null);
  const afterRef = useRef(null);
  const windowSize = useWindowSize();
  const partners = arrayPartners?.data;

  const logosPerSlide = windowSize.width <= 500 ? 8 : 12;
  const slides = partners
    ? Array.from(
      { length: Math.ceil(partners.length / logosPerSlide) },
      (_, index) => {
        const start = index * logosPerSlide;
        const end = start + logosPerSlide;
        return partners.slice(start, end);
      }
    )
    : [];

  const halfIndex = Math.ceil(slides.length / 2);

  const swiper1Ref = useRef();
  const swiper2Ref = useRef();

  useEffect(() => {
    swiper1Ref.current.controller.control = swiper2Ref.current;
    swiper2Ref.current.controller.control = swiper1Ref.current;
  }, []);

  return (
    <div className="lg:amb-container">
      <Swiper
        onSwiper={(swiper) => {
          swiper1Ref.current = swiper;
        }}
        slidesPerView={1.11}
        modules={[Navigation, Pagination, Controller]}
        pagination={{
          clickable: true,
          type: "bullets",
          el: paginationRef.current,
          currentClass: "bg-neutral-900",
          bulletClass: "block w-6 h-1 bg-gray-200",
          bulletActiveClass: "bg-neutral-900",
        }}
        navigation={{
          nextEl: afterRef.current,
          prevEl: beforeRef.current,
          hiddenClass: "hidden",
          disabledClass: "text-neutral-50 border-neutral-50",
        }}
      >
        {slides.slice(0, halfIndex).map((slide, slideIndex) => (
          <SwiperSlide
            key={slideIndex}
            className={`grid grid-rows-2 ${windowSize.width <= 500 ? "grid-cols-4" : "grid-cols-6"
              } `}
          >
            {slide.map((partner, logoIndex) => (
              <div
                key={logoIndex}
                className="flex h-[64px] w-full items-center justify-center border p-2 md:h-[91px] lg:h-[140px]"
              >
                <Image
                  src={partner?.attributes?.logo?.data?.attributes?.url}
                  alt={`Logo ${partner.name}`}
                  width={135}
                  height={100}
                  className="max-h-[100px]"
                />
              </div>
            ))}
          </SwiperSlide>
        ))}
      </Swiper>

      <div className="my-2 text-center lg:my-8 lg:flex lg:items-center lg:justify-center">
        <button
          ref={beforeRef}
          className="absolute left-10 hidden h-fit border-2 border-black p-4 hover:bg-black hover:text-white lg:flex"
        >
          <ArrowLeftIcon className="h-4 w-4" />
        </button>
        <Text.Headline as="p" className="text-[22px] font-bold">
          ¡Muchas gracias&nbsp;
        </Text.Headline>
        <Text.Headline className="text-[22px] font-bold">
          a nuestros colaboradores!
        </Text.Headline>
        <button
          ref={afterRef}
          className="absolute right-10 hidden h-fit border-2 border-black p-4 hover:bg-black hover:text-white lg:flex"
        >
          <ArrowRightIcon className="h-4 w-4" />
        </button>
      </div>

      <Swiper
        onSwiper={(swiper) => {
          swiper2Ref.current = swiper;
        }}
        slidesPerView={1.11}
        modules={[Pagination, Controller]}
      >
        {slides.slice(halfIndex).map((slide, slideIndex) => (
          <SwiperSlide
            key={slideIndex}
            className={`grid grid-rows-2 ${windowSize.width <= 500 ? "grid-cols-4" : "grid-cols-6"
              } `}
          >
            {slide.map((partner, logoIndex) => (
              <div
                key={logoIndex}
                className="flex h-[64px] w-full items-center justify-center border p-2 md:h-[91px] lg:h-[140px]"
              >
                <Image
                  src={partner?.attributes?.logo?.data?.attributes?.url}
                  alt={`Logo ${partner.id}`}
                  width={135}
                  height={100}
                  className="max-h-[100px]"
                />
              </div>
            ))}
          </SwiperSlide>
        ))}
      </Swiper>
      <div
        className="my-4 flex cursor-pointer  items-center justify-center gap-3 pt-5"
        ref={paginationRef}
      ></div>
    </div>
  );
}
